import SchemaMarkup from "../Components/SchemaMarkup";

const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",

    "@id": "https://msayurved.com/#organization",

    "name": "Dr. Jigar Gor Ayurveda",
    "url": "https://msayurved.com/",

    "logo": {
      "@type": "ImageObject",
      "url": "https://msayurved.com/logo.svg"
    },

    "description":
      "Ayurvedic healthcare organization providing personalized Ayurvedic consultations and treatments.",

    "telephone": "+91-9099094847",

    "email": "dr.jigargor@yahoo.com",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Narayan Complex",
      "addressLocality": "Madhapar",
      "addressRegion": "Gujarat",
      "postalCode": "370020",
      "addressCountry": "IN"
    },

    "sameAs": [
      "https://www.facebook.com/dr.jigargor.ayurveda",
      "https://www.instagram.com/dr.jigargor.ayurveda/",
      "https://www.youtube.com/@dr.jigargor.ayurveda"
    ]
  };

  return <SchemaMarkup data={schema} />;
};

export default OrganizationSchema;